import React from 'react'

import { MobileTradingAccountCard } from '@pages/Traders-Room/Trading-Accounts/MobileTradingAccountCard'

import { CommonPaths } from '@utils/path-common'

import { PlatformType } from '@model/PlatformTypeDto'
import { TradingAccount } from '@model/TradingAccount'
import { WalletDto } from '@model/WalletDto'

import { CreateTradingAccountCTA } from '../components/CreateTradingAccountCTA'

interface MobileTradingAccountCardsProps {
  tableQuery: { data: TradingAccount[]; isLoading: boolean }
  platformTypes: PlatformType[]
  wallets: WalletDto[]
  onLeverageChange: (args: { tradingAccount: TradingAccount; restricted?: boolean }) => void
  onDisplayDynamicLeverageInfo?: () => void
  tradingAccountParam: string | null
}

export const MobileTradingAccountCards: React.FC<MobileTradingAccountCardsProps> = (props) => {
  const { tableQuery, platformTypes, tradingAccountParam, wallets } = props
  const { onLeverageChange, onDisplayDynamicLeverageInfo } = props

  if (!tableQuery.data.length && !tableQuery.isLoading) {
    return <CreateTradingAccountCTA createTradingAccountPath={CommonPaths.NewLiveTradingAccount} />
  }

  return tableQuery.data.map((tradingAccount) => (
    <MobileTradingAccountCard
      tradingAccount={tradingAccount}
      wallet={wallets.find((x) => x.id === tradingAccount.wallet.id)}
      platformTypes={platformTypes}
      onLeverageChange={onLeverageChange}
      onDisplayDynamicLeverageInfo={onDisplayDynamicLeverageInfo}
      isDeeplink={tradingAccountParam === tradingAccount.id}
      key={tradingAccount.id}
    />
  ))
}
